"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: quiz/quiz-leaderboard.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fquiz%2Fquiz-leaderboard.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserChoiceScore = exports.QuizLeaderboardPosition = exports.AnonQuizLeaderboardUser = exports.FriendQuizLeaderboardUser = exports.QuizLeaderboardUser = exports.QuizLeaderboardEntry = exports.QuizLeaderboard = exports.QuizLeaderboardStats = exports.LeaderboardInfo = void 0;
const protobufPackage = 'com.step.quiz.proto';
function createBaseLeaderboardInfo() {
    return { leaderboardId: '', startTimeMs: '0', endTimeMs: '0' };
}
exports.LeaderboardInfo = {
    fromJSON(object) {
        const message = {
            leaderboardId: isSet(object.leaderboardId) ? globalThis.String(object.leaderboardId) : '',
            startTimeMs: isSet(object.startTimeMs) ? globalThis.String(object.startTimeMs) : '0',
            endTimeMs: isSet(object.endTimeMs) ? globalThis.String(object.endTimeMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.leaderboardId !== '') {
            obj.leaderboardId = message.leaderboardId;
        }
        if (message.startTimeMs !== '0') {
            obj.startTimeMs = message.startTimeMs;
        }
        if (message.endTimeMs !== '0') {
            obj.endTimeMs = message.endTimeMs;
        }
        return obj;
    },
    create(base) {
        return exports.LeaderboardInfo.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLeaderboardInfo();
        message.leaderboardId = object.leaderboardId ?? '';
        message.startTimeMs = object.startTimeMs ?? '0';
        message.endTimeMs = object.endTimeMs ?? '0';
        return message;
    },
};
function createBaseQuizLeaderboardStats() {
    return { position: 0, score: 0, leaderboardId: '' };
}
exports.QuizLeaderboardStats = {
    fromJSON(object) {
        const message = {
            position: isSet(object.position) ? globalThis.Number(object.position) : 0,
            score: isSet(object.score) ? globalThis.Number(object.score) : 0,
            leaderboardId: isSet(object.leaderboardId) ? globalThis.String(object.leaderboardId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.position !== 0) {
            obj.position = Math.round(message.position);
        }
        if (message.score !== 0) {
            obj.score = Math.round(message.score);
        }
        if (message.leaderboardId !== '') {
            obj.leaderboardId = message.leaderboardId;
        }
        return obj;
    },
    create(base) {
        return exports.QuizLeaderboardStats.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQuizLeaderboardStats();
        message.position = object.position ?? 0;
        message.score = object.score ?? 0;
        message.leaderboardId = object.leaderboardId ?? '';
        return message;
    },
};
function createBaseQuizLeaderboard() {
    return { entries: [] };
}
exports.QuizLeaderboard = {
    fromJSON(object) {
        const message = {
            entries: globalThis.Array.isArray(object?.entries)
                ? object.entries.map((e) => exports.QuizLeaderboardEntry.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.entries?.length) {
            obj.entries = message.entries.map((e) => exports.QuizLeaderboardEntry.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.QuizLeaderboard.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQuizLeaderboard();
        message.entries = object.entries?.map((e) => exports.QuizLeaderboardEntry.fromPartial(e)) || [];
        return message;
    },
};
function createBaseQuizLeaderboardEntry() {
    return {
        user: exports.QuizLeaderboardUser.fromPartial({}),
        position: exports.QuizLeaderboardPosition.fromPartial({}),
    };
}
exports.QuizLeaderboardEntry = {
    fromJSON(object) {
        const message = {
            user: isSet(object.user)
                ? exports.QuizLeaderboardUser.fromJSON(object.user)
                : exports.QuizLeaderboardUser.fromPartial({}),
            position: isSet(object.position)
                ? exports.QuizLeaderboardPosition.fromJSON(object.position)
                : exports.QuizLeaderboardPosition.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.user !== undefined) {
            obj.user = exports.QuizLeaderboardUser.toJSON(message.user);
        }
        if (message.position !== undefined) {
            obj.position = exports.QuizLeaderboardPosition.toJSON(message.position);
        }
        return obj;
    },
    create(base) {
        return exports.QuizLeaderboardEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQuizLeaderboardEntry();
        message.user = (object.user !== undefined && object.user !== null)
            ? exports.QuizLeaderboardUser.fromPartial(object.user)
            : exports.QuizLeaderboardUser.fromPartial({});
        message.position = (object.position !== undefined && object.position !== null)
            ? exports.QuizLeaderboardPosition.fromPartial(object.position)
            : exports.QuizLeaderboardPosition.fromPartial({});
        return message;
    },
};
function createBaseQuizLeaderboardUser() {
    return { anon: undefined, friend: undefined };
}
exports.QuizLeaderboardUser = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.anon)) {
            message.anon = exports.AnonQuizLeaderboardUser.fromJSON(object.anon);
        }
        if (isSet(object.friend)) {
            message.friend = exports.FriendQuizLeaderboardUser.fromJSON(object.friend);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.anon !== undefined) {
            obj.anon = exports.AnonQuizLeaderboardUser.toJSON(message.anon);
        }
        if (message.friend !== undefined) {
            obj.friend = exports.FriendQuizLeaderboardUser.toJSON(message.friend);
        }
        return obj;
    },
    create(base) {
        return exports.QuizLeaderboardUser.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQuizLeaderboardUser();
        message.anon = (object.anon !== undefined && object.anon !== null)
            ? exports.AnonQuizLeaderboardUser.fromPartial(object.anon)
            : undefined;
        message.friend = (object.friend !== undefined && object.friend !== null)
            ? exports.FriendQuizLeaderboardUser.fromPartial(object.friend)
            : undefined;
        return message;
    },
};
function createBaseFriendQuizLeaderboardUser() {
    return { phoneNumber: '' };
}
exports.FriendQuizLeaderboardUser = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.phoneNumber)) {
            message.phoneNumber = globalThis.String(object.phoneNumber);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.phoneNumber !== undefined && message.phoneNumber !== '') {
            obj.phoneNumber = message.phoneNumber;
        }
        return obj;
    },
    create(base) {
        return exports.FriendQuizLeaderboardUser.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFriendQuizLeaderboardUser();
        message.phoneNumber = object.phoneNumber ?? '';
        return message;
    },
};
function createBaseAnonQuizLeaderboardUser() {
    return { userName: '', avatarUrl: '' };
}
exports.AnonQuizLeaderboardUser = {
    fromJSON(object) {
        const message = {
            userName: isSet(object.userName) ? globalThis.String(object.userName) : '',
            avatarUrl: isSet(object.avatarUrl) ? globalThis.String(object.avatarUrl) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userName !== '') {
            obj.userName = message.userName;
        }
        if (message.avatarUrl !== '') {
            obj.avatarUrl = message.avatarUrl;
        }
        return obj;
    },
    create(base) {
        return exports.AnonQuizLeaderboardUser.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAnonQuizLeaderboardUser();
        message.userName = object.userName ?? '';
        message.avatarUrl = object.avatarUrl ?? '';
        return message;
    },
};
function createBaseQuizLeaderboardPosition() {
    return { place: 0, score: 0 };
}
exports.QuizLeaderboardPosition = {
    fromJSON(object) {
        const message = {
            place: isSet(object.place) ? globalThis.Number(object.place) : 0,
            score: isSet(object.score) ? globalThis.Number(object.score) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.place !== 0) {
            obj.place = Math.round(message.place);
        }
        if (message.score !== 0) {
            obj.score = Math.round(message.score);
        }
        return obj;
    },
    create(base) {
        return exports.QuizLeaderboardPosition.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseQuizLeaderboardPosition();
        message.place = object.place ?? 0;
        message.score = object.score ?? 0;
        return message;
    },
};
function createBaseUserChoiceScore() {
    return { participationScore: 0, answerScore: 0, speedBonus: 0, streakBonus: 0 };
}
exports.UserChoiceScore = {
    fromJSON(object) {
        const message = {
            participationScore: isSet(object.participationScore)
                ? globalThis.Number(object.participationScore)
                : 0,
            answerScore: isSet(object.answerScore) ? globalThis.Number(object.answerScore) : 0,
            speedBonus: isSet(object.speedBonus) ? globalThis.Number(object.speedBonus) : 0,
            streakBonus: isSet(object.streakBonus) ? globalThis.Number(object.streakBonus) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.participationScore !== 0) {
            obj.participationScore = Math.round(message.participationScore);
        }
        if (message.answerScore !== 0) {
            obj.answerScore = Math.round(message.answerScore);
        }
        if (message.speedBonus !== 0) {
            obj.speedBonus = Math.round(message.speedBonus);
        }
        if (message.streakBonus !== 0) {
            obj.streakBonus = Math.round(message.streakBonus);
        }
        return obj;
    },
    create(base) {
        return exports.UserChoiceScore.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserChoiceScore();
        message.participationScore = object.participationScore ?? 0;
        message.answerScore = object.answerScore ?? 0;
        message.speedBonus = object.speedBonus ?? 0;
        message.streakBonus = object.streakBonus ?? 0;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=quiz-leaderboard.js.map